import { z } from 'zod'

export const ADMINPERSONABASEPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaBasePostResponseSchema = z.unknown()
export type AdminPersonaBasePostResponse = z.infer<typeof adminPersonaBasePostResponseSchema>
